import * as catalogos from './catalogos/es';
export const locale = {
  lang: 'es',
  data: {
    'RESPONDE': catalogos.answer,
    'CONSULTATABLA': {
      'TITULO': 'Consulta general',
      'HEADER': 'Empresas:',
      'BUSCAR': 'Buscar empresa',
      'BUSCAR_PLACEH': 'Escriba el nombre de la empresa que desee buscar',
      'EMPRESA': 'Empresa',
      'MESSAGE3':'<span> ¿Está seguro que desea hacer un borrado lógico del producto?, ingrese el texto en rojo en la caja de texto: ',
      'MESSAGE4':'</span>',
      'CANCELAR': 'Cancelar',
      'COMFIR': 'Confirmar',
      'PROC_DELE_PROD':'Eliminando producto',
      'SUCC_DELE_PROD':'Se elimino correctamente el producto',
      'DELE_PRODU':'Eliminar producto',
      'TEX_VERS_RESULT_OPC1':'Versión default',
      'TEX_VERS_RESULT_OPC2':'Versión personalizada',
      'TEX_VERS_RESULT_LAB':'Versión personalizada',
      'TEX_PLAC_RESULT_LAB':'Ingresar la versión personalizada',
      'TEX_MOD_RESULT_VERS':'Es necesario ingresar el tipo de versión de resultados',
      'TIPO_EMPRESA':{
        '1':'Cultural Go',
        '2':'Cultural Go express',
        '3':'Cultural Go swift',
      },
      'SELECT_PLANTILLA': 'Seleccione una plantilla',
      'SELECT_EMAIL_PLANTILLA': 'Seleccione una plantilla de comunicación',
      'ACCION': 'Acciones',
      'CREAT_DATE_EMP':'Fecha de creación',
      'TYP_REGISTR_EMP':'Tipo de resgistro',
      'AUTOR_EMP':'Autor',
      'DETALLE': 'Productos',
      'MANAGER_TI': 'Responsable de TI',
      'STATUS':'Estatus de encuesta',
      'EMA_HISTO':'Historial correo',
      'LABEL1': 'Datos de la empresa',
      'DESCDETAIL': 'Los formularios reactivos angulares facilitan un estilo de programación reactivo que favorece la gestión explícita de los datos que fluyen entre un modelo de datos sin interfaz de usuario (generalmente recuperado de un servidor) y un modelo de formulario orientado a la interfaz de usuario que conserva los estados y valores de los controles HTML en pantalla . Las formas reactivas ofrecen la facilidad de usar patrones reactivos, pruebas y validación',
      'DETAIL': 'Detalle',
      'SECTOR': 'Sector:',
      'SUBSECTOR': 'Sub-sector:',
      'RANKING': 'Clasificación:',
      'SELECCIONE_FECHA': 'Fecha',
      'SELECT_CSSID': 'Año de aplicación',
      'SELECT_CSSIDR': 'Año de ranking',
      'TIPORANKING': 'Tipo de ranking',
      'TIP_PRODU': 'Tipo producto',
      'TIP_PLAN_PRO': 'Nombre plantillas',
      'TIP_DIS_PRO': 'Diseño',
      'SELECT_CSSID2': 'Seleccione un diseño',
      'SELECT_RESULTS': 'Seleccione un producto',
      'SURVEYTK_TITU': 'Clave de la encuesta',
      'SURVEYTK_DESC': 'Escriba la clave de la encuesta para este producto',
      'TABLEAUVER_TITU': 'Versión de resultados',
      'TABLEAUVER_DESC': 'Escriba la versión del sistema de resultados para este producto',
      'IDOPORTUNITY': 'Id de oportunidad (Sales Force)',
      'NAMEOPORTUNITY': 'Nombre de oportunidad (Sales Force)',
      'IDTYPERESULT': 'Tipos de resultados',
      'NAM_USE_SWIFT':'Nombre usuario',
      'TO_USE_SWIFT':'Total de colaboradores',
      'EMA_USE_SWIFT':'Correo usuario',
      'PASS_USE_SWIFT':'Constraseña usuario',
      'CAT_RES':{
        '1':'Resultados completos',
        '2':'Resultados básicos',
      },
      'PROYECTMANAGER': 'Jefe de proyecto',
      'PROYECTMANAGER_MAIL': 'Correo electrónico del jefe de proyecto',
      'CONFIGURE': 'click aquí para configurar',
      'INFOR': 'Info',
      'TIPO': 'Tipo:',
      'Reactivos': 'Reactivos',
      'NPS': 'NPS',
      'Demograficos': 'Demográficos',
      'Forall': 'Forall',
      'Adicionales': 'Adicionales',
      'Control': 'Control',
      'Abiertas': 'Abiertas',
      'URL':'Link',
      '0': 'Diseño de iconos Blancos',
      '1': 'Diseño de iconos Amarillos',
      '4': 'Diseño de iconos Círculos',
      'ADDPRODUCTS': 'Agregar productos',
      'ADD': 'Agregar',
      'NAME_SURVEY':'Nombre encuesta:',
      'UPDATE_NAME_SURVEY':'Actualizando el nombre',
      'LABELCONTRATADOS': 'Productos en uso:',
      'PRODUCTOS': catalogos.productos,
      'PRODUCTOSTURQUIA': catalogos.productosTurquia,
      'CATEGORIAS': catalogos.categorias,
      'GETLISTAEMP': 'Cargando lista de empresas registradas',
      'EDITAR': 'Editar datos de la empresa',
      'LOGIN': 'Iniciar sesión',
      'PAGINATOR_1': 'de',
      'PAGINATOR_2': 'empresas',
      'TIMELINE': 'Línea de tiempo de R.T.',
      'PAQUETES': 'Paquetes',
      'ELIMINAR': 'Eliminar empresa',
      'CORREOMODIF': 'Este producto tiene cambios en el cuerpo del correo electrónico',
      'CORREOMODIFMODAL': 'Hay nuevos cambios de correo electrónico pendientes de validación en uno o más productos. Por favor verifíquelos',
      'CORREOMODAL_2': 'Actualmente hay nuevos cambios de correo electrónico pendientes de validación',
      'MODIFBTN': 'Configuraciones del producto',
      'INF_BTN': 'Información del producto',
      'INF_PROD_SEL': 'Información del producto',
      'VALIDMAIL_1': 'Validar los cambios',
      'VALIDMAIL_2': 'Correo validado',
      'VALIDMAIL_3': '¿Desea validar los cambios realizados al mensaje?',
      'VALIDMAIL_4': 'Los cambios al correo electrónico fueros validados correctamente',
      'VALIDMAIL_5': 'Revertir los cambios',
      'VALIDMAIL_6': '¿Desea revertir los cambios realizados al mensaje? Se usará la plantilla default.',
      'VALIDMAIL_7': 'Los cambios al correo electrónico fueron revertidos',
      'VALIDMAIL_8': 'Correo rechazado',
      'VALIDMAIL_9': 'Habilitar edición a la empresa',
      'VALIDMAIL_10': '¿Desea habilitar nuevamente la edición del correo electrónico a la empresa?',
      'VALIDMAIL_11': 'La edición fue habilitada para la empresa',
      'VALIDMAIL_12': 'Editar el correo',
      'VALIDMAIL_13': 'Ahora puede editar el correo enviado por la empresa',
      'SINCORREOS': 'No hay correos por validar',
      'FILEMANODS': 'Gestor de archivos',
      'TEX-MENS-1':'La empresa',
      'TEX-MENS-2':'no cuenta con usuarios',
      'FILEMAN_PRIV': 'Carpeta privada',
      'FILEMAN_PUB': 'Carpeta pública',
      'USUARIO':'Usuario',
      'AL':'al',
      'SEN_EMAIL_REQ':'¿Desea enviar el correo electrónico de requerimientos técnicos?',
      'SEN_EMAIL_REQ_PROD':'¿Está seguro de enviar el correo electrónico de requerimientos técnicos?',
      'EMAIL_REQ_PLACE':'Seleccione un idioma',
      'EMAIL_REQ_INTRO':'Seleccione un idioma para continuar ',
      'WARN_SEN_EMAIL_REQ_PROD':'Pará continuar hay que seleccionar un idioma',
      'ETIQUE_SEN_EMAIL_REQ_PROD':'Envió Correo Requerimientos Técnicos',
      'TOOLTI_SEN_EMA':'Enviar correo',
      'ESTA_EMA_TRUE':'*Correo enviado',
      'ESTA_EMA_FALSE':'*Correo no enviado',
      'SEN_EMAIL_MODAL':'Enviando correo electrónico......',
      'RTINFO': 'Información de requerimientos técnicos',
      'TOOTI_RES_EMPR':'Resultados empresing',
      'WARNI_SELCT_CHECK':'Para continuar con la búsqueda es obligatorio marcar al menos una casilla',
      'REQ':{
        'BTNSI':'Sí',
        'BTNNO':'No',
        'MENSAJE1':'Desea desactivar los requerimientos técnicos?',
        'MENSAJE2':'Desea activar los requerimientos técnicos?',
      },
      'EDITORMAILODS': {
        'OPCION_1': 'Activar editor de correos a este producto',
        'OPCION_2': 'Validación automática de cambios',
        'OPCION_3': 'Activar requerimientos técnicos dentro del flujo de encuesta',
        'OPCION_4': 'Activar validacion de encuestas para Focus Area',
        'OPCION_5': 'Permitir cambiar tiempo de aplicacion',
        'OPCION_6': 'Permitir hacer prórrogas',
        'OPCION_7':'Cambio en requerimientos técnicos dentro del flujo de encuesta correcto',
        'OPCION_8': 'Número de recordatorios asignables',
        'OPCION_9': 'Activar edición de fecha de cierre',
        'OPCION_10': 'Activar reapertura de pasos',
        'OPCION_11_ENTREGABLES': 'Mostrar resultados de entregables en Portal de Conteos',
        'OPCION_11_RANKING': 'Mostrar resultados de certificación & ranking en Portal de Conteos',
        'OPCION_12':'Activar la protección de encuestas con PIN de usuario',
        'OPCION_13':'Habilitar la pregunta de validación aleatoria',
        'OPCION_14':'Mostrar el cuadro de instrucciones en la aplicación de la encuesta',
        'OPCION_15':'Mostrar cuadro de apoyo en la aplicación de la encuesta',
        'OPCION_16':'Mostrar el nombre de usuario en la aplicación de la encuesta',
        'MODAL_OP11_ON': 'Se activó la función de reapertura de pasos para este producto',
        'MODAL_OP12_OF': 'Se desactivó la función de reapertura de pasos para este producto',
        'MODAL_OP1_ON': 'Se activó el editor de correos electrónicos para este producto',
        'MODAL_OP1_OFF': 'Se desactivó el editor de correos electrónicos para este producto',
        'MODAL_OP2_ON': 'Se activó la validación automática de cambios para este producto',
        'MODAL_OP2_OFF': 'Se desactivó la validación automática de cambios para este producto',
        'MODAL_OP6_ON': 'Se activó el permitir hacer prórrogas para este producto',
        'MODAL_OP6_OFF': 'Se desactivó el permitir hacer prórrogas para este producto',
        'MODAL_OP7_ON': 'Se cambió el número de recordatorios asignables para este producto',
        'MODAL_OP8_ON': 'Se activó la edición de la fecha de cierre de encuesta para este producto',
        'MODAL_OP8_OFF': 'Se desactivó la edición de la fecha de cierre de encuesta para este producto',
        'MODAL_OP11_ENTREGABLES_ON': 'Se activó la muestra de resultados de entregables ',
        'MODAL_OP11_ENTREGABLES_OFF': 'Se desactivó la muestra de resultados de entregables',
        'MODAL_OP11_RANKING_ON': 'Se activó la muestra de resultados de certificación & ranking',
        'MODAL_OP11_RANKING_OFF': 'Se desactivó la muestra de resultados de certificación & ranking',
        'MODAL_PIN_ON':'Se activó el pin en la encuesta',
        'MODAL_PIN_OFF':'Se desactivó el pin en la encuesta',
        'MODAL_PRECONTROL_ON':'Se activó la pregunta de validación aleatoria',
        'MODAL_PRECONTROL_OFF':'Se desactivó la pregunta de validación aleatoria',
        'MODAL_OP14_ON':'Se activó mostrar el cuadro de instrucciones en la aplicación de la encuesta',
        'MODAL_OP14_OFF':'Se desactivó mostrar el cuadro de instrucciones en la aplicación de la encuesta',
        'MODAL_OP15_ON':'Se activó mostrar cuadro de apoyo en la aplicación de la encuesta',
        'MODAL_OP15_OFF':'Se desactivó mostrar cuadro de apoyo en la aplicación de la encuesta',
        'MODAL_OP16_ON':'Se activó mostrar el nombre de usuario en la aplicación de la encuesta',
        'MODAL_OP16_OFF':'Se desactivó mostrar el nombre de usuario en la aplicación de la encuesta',
        'TITUOPTS': 'Opciones',
        'TITUCORRS': 'Correos por validar',
        'SELLANG': 'Seleccione un idioma de la lista para ver el correo',
        'SELLANG_L': 'Seleccione un idioma',
        'ASUNTO': 'Asunto del correo',
        'ASUNTOPILOTO': 'Asunto del correo piloto',
        'WAIT':'Realizando cambio',
        'ULTD': 'Ilimitados',
        'CLOUD_LEGACY': 'Activar versión actualizada del gestor de archivos',
        'CUSTOM_TEXT_CERT': 'Activar texto del certificado multi sitio',
        'CUSTOM_TEXT_CERT_EDIT': 'Editar el texto del certificado',
        'TEXT_SECC_CONF_VOIC': 'Mostrar sección configuración de voz',
        'SAVED_CHANGES': 'Se guardó el cambio correctamente',
        'CUSTOM_TEXT': {
          'TITULO': 'Enliste los países en los que el certificado multi sitio tiene cobertura',
          'SUBTITULO': 'Escriba el nuevo texto',
          'SUBTITULO2': 'Advertencia, si cambia el texto y da clic al botón Aceptar, el texto actual será sobreescrito',
          'HINT': 'Texto del certificado',
          'OK': 'Aceptar',
          'CANCEL': 'Cancelar',
          'SAVED_CHANGES': 'Se guardó el texto correctamente',
          'CURRENT_T1': 'Texto actual de multi sitio',
          'CURRENT_T2': 'El texto actual de multi sitio es muy largo, para visualizarlo haga clic en el botón Editar',
        }
      },
      'ASOCIARCERTIFICAR':{
        'CHECK':'Asociar culture audit a un certificar',
        'INPUT':'Certificar a asociar',
        'INPUT_2':'Producto a asociar',
        'CERTIFICAR':'Certificar',
        'MEDIR':'Medir',
      },
      'LOG_SISTEMA':{
        'TITULO':'Log del sistema',
        'BUSCADOR':'Buscar resultado',
        'PLACEHOLDER':'Buscar',
        'ACTUALIZAR':'Actualizar log',
        'PAGINA':'Página',
        'CARGA':'Cargando datos...',
        'TABLA':{
          'IMAGEN':'Imagen',
          'IP':'IP Cliente',
          'USER':'Usuario',
          'COMPANY':'Empresa',
          'PLATFORM':'Plataforma',
          'STATUS':'Estatus',
          'RESULT':'Resultado',
          'DATE':'Fecha',
        },
      },
      'LOG_SENDGRIND':{
        'TITULO':'Log de SendGrid',
        'OPCION':'Seleccione una opción:',
        'TOOLTIP':'Buscar estatus',
        'TABLA':{
          'USUARIO':'Usuario',
          'EMAIL':'Email',
          'ASUNTO':'Asunto',
          'ESTATUS':'Estatus'
        },
        'DIALOG_SENDGRIND':{
          'TITTULO':'Información del correo',
          'TO':'A',
          'FROM':'De',
          'SUBJECT':'Asunto',
          'HISTORIAL':'Historial de correo',
          'ESTATUS':'Estado',
          'ABIERTO':'Veces abierto:',
          'ULTIMO_EVENTO':'Último evento:',
          'SIN_CORREOS':'No se cuenta con su historial de correo!',
          'BOTON':'Cerrar',
          'NOTE':'NOTA: La fecha / hora que se muestra en la lista se establece en la hora local de  ',
        },
      },
      'CONFIR_CAMBIOS_SECCION':'Actualmente ya esta creada la encuesta,\n\n¿Está seguro de realizar los cambio?\n\n*En caso de confirmar generar nuevamente la encuesta',
      'MODAL_CAMBIOS_SECCION':'Actualizando secciones',
      'TIT_MOD_AGRE_ENCU':'Nuevo proceso de encuesta',
      'TEX_NAM_SUR':'Nombre de encuesta:',
      'TEX_PLA_SUR':'Selección de plantilla',
      'BTN_AGRE_SUR':'Agregar',
      'PLA_TEX_NAM_SUR':'Nombre de encuesta:',
      'PLA_TEX_PLA_SUR':'Selección de plantilla',
      'WARNI_NOT_SURV_NOM35':'Actualmente no se ha generado la encuesta',
      'MODAL_CREAT_INFRA':'Se está creando la infraestructura, por favor espere',
      'MODAL_ERROR_INFRA':'Ocurrió un error al crear la infraestructura',
    },
    'GESTORSTATUS': {
      'BOTACCESO': 'Información de productos',
      'TITULO': 'Productos adquiridos',
      'PRODUCTOS':{
        'CERTIFICAR': 'Certificar',
        'MEDIR': 'Medir',
        'PULSE': 'Pulse Check',
        'FOCUS': 'Focus Area',
        'NUMPROD': 'Número de productos: ',
        'BOTACCESO': 'Ver productos',
        'NOPRODUCTOS': 'No cuenta con productos adquiridos'
      },
      'PRODSINFO': {
        'ADQUIRIDOS': 'Productos adquiridos',
        'SELECCIONE': 'Seleccione un producto de la lista para consultar su información'
      },
      'STATUS': {
        'LISTA': 'Lista de pasos',
        'CURRENT': 'Estado del paso',
        'INFO': 'En esta lista se muestra el estado actual de cada paso del proceso de certificacion.\n\nPuede cambiar el estado de un paso completado a "No completado" haciendo clic en el selector de estado.\n\nNota: Algunos estados se pueden cambiar sólo bajo ciertas condiciones.',
        'NO': 'No completado',
        'SI': 'Paso completado',
        'TOOLTIP': {
          'HELP': 'Haga clic para saber más',
          'SLIDER': 'Haga clic aquí para cambiar el estado de este paso'
        }
      }
    },
    'ALERTS': {
      'OK': 'OK',
      'ODSINSERTOK': 'La empresa fue registrada correctamente',
      'ODSFAILINSERT': 'El proceso de registro falló, por favor intente nuevamente',
      'COLPLETEFORM1': 'Por favor complete el paso 1',
      'COLPLETEFORM2': 'Por favor complete el paso 2',
      'COLPLETEFORM3': 'Por favor complete el paso 3',
      'COLPLETEFORM4': 'Por favor complete el paso 4',
      'COLPLETEFORM5': 'Por favor complete el paso 5',
      'ODSEXIST': 'La empresa ya está registrada en el sistema. La información no se almacenó',
      'MAIL':'¿Desea volver enviar el correo a los diferentes responsables?',
      'RSPSI':'Sí',
      'RSPNO':'No',
      'LABEL01':'Ya tienes un producto de NOM 035 asignado',
      'FIELD':'Falta ingresar la liga de acceso',
      'PASSWORD': {
        'LONGITUD': 'La contraseña debe contar con una longitud de al menos ocho caracteres',
        'MINUSCULAS': 'La contraseña debe contar con al menos una letra minúscula',
        'MAYUSCULAS': 'La contraseña debe contar con al menos una letra mayúscula',
        'NUMEROS': 'La contraseña debe contar con al menos un caracter numérico',
        'ESPCHARS': 'La contraseña debe contar con al menos un caracter especial, no alfanumérico',
        'VALIDACION': 'Ocurrió un problema al validar la contraseña, por favor escribala nuevamente y vuelva a intentar crear el usuario'
      }
    },
    'TI_MANAGER': {
      'TITULO': 'Responsable de TI',
      'DESCRIPTION': 'Ingresa los datos del responsable de TI para enviar la información y configuraciones necesarias que se deberán ejecutar antes de la aplicación de la encuesta',
      'DATOS': 'Datos',
      'NOMBRE': 'Nombre: ',
      'APELLIDOS': 'Apellidos: ',
      'EMAIL': 'Correo electrónico:',
      'TELEFONO': 'Teléfono: ',
      'EXTENSION': 'Extensión: ',
      'CELULAR': 'Celular: ',
    },
    'PERFILES': {
      'CABECERA':{
        'TITULO': 'CREADOR DE PERFILES',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'BOTONES':{
        'BOT1':{
          'TITULO': 'Perfil de empresa',
          'BOTON': 'Crear'
        },
        'BOT2':{
          'TITULO': 'Perfil de usuario',
          'BOTON': 'Administrador',
        },
        'BACK': 'Regresar',
        'NEXT': 'Siguiente',
        'RESET': 'Reiniciar',
        'EDIT': 'Guardar'
      },
      'EMPRESA':{
        'WAIT': 'Espere...',
        'TITUHEAD': 'Perfil de empresa',
        'CLOUD': 'Carpeta privada',
        'INFO': 'Cree el perfil para una empresa',
        'INFOMOD': 'Puede modificar los datos del perfil de esta empresa <b>(los cambios se guardan automáticamente)</b>',
        'PDF':{
          'BOTONDESCARGA':'Descargar información en pdf',
          'FECHA':'Fecha: ',
          'HORA':'Hora: ',
          'MODAL':'Generando archivo para su descarga...',
        },

        'ACTUALIZARCA':{
          'ACTUALIZARCA':'Actualizar Culture Audit',
          'ACTUALIZARCA_BRI':'Actualizar Culture Brief',
          'ACTUALIZARCA_ACTIAN':'Actualizar Plan de acción',
          'CERRAR':'Cerrar',
          'SUCCESS':'Culture Audit actualizado con éxito',
          'SUCCESS_ACTION':'Plan de acción actualizado con éxito',
          'ERROR':'Error, su Culture Audit no cuenta con un producto certificar',
          'IRACA_CGOX': 'Ir a Culture Audit',
          'ACTUALIZAR_ICCA':'Actualizar ICCA',
        },

        'ACTUALIZAR_BD':{
          'TITULO':'Instrucciones',
          'INSTRUCCIONES':{
            'INSTRUCCION_1':'Descargue la base de datos de colaboradores que almaceno dentro de la plataforma.',
            'INSTRUCCION_2':'Descargue la plantilla proporcionada por la plataforma, y copie los datos de su base de datos de colaboradores a esta plantilla.',
            'INSTRUCCION_3':'Realice las modificaciones necesarias en su base de datos de colaboradores.',
            'INSTRUCCION_4':'Una vez terminadas las modificaciones a su base de datos de colaboradores, elimine su base de datos de colaboradores anterior.',
            'INSTRUCCION_5':'De clic en el botón para subir su base de datos de colaboradores actualizada y de clic en aceptar.'
          },
        },

        'SECCIONES':{
          'SEC1': {
            'TITULO': 'Información de la empresa',
            'TITULOPDF': 'Información de la empresa ',
            'NOMEMP': 'Nombre de la empresa: ',
            'NOM': 'Nombre: ',
            'SECTORREQUIRED': 'El sector es requerido',
            'SUBSECTORREQUIRED': 'El sub-sector es requerido',
            'ANIOFU': 'Año de fundación ',
            'INSTITUTO': 'Instituto ',
            'SALESFORCE': 'ID de cliente ',
            'CODE': 'Código de proyecto ',
            'SALES_REQUIRED': 'El ID de cliente es requerido',
            'CODE_REQUIRED': 'El código de proyecto es requerido',
            'INSTITUTO_REQUIRED': 'El instituto es requerido',
            'COMPANY': 'Empresa ',
            'COMPANY_REQUIRED': 'El nombre de la empresa es requerido',
            'CAMPO_INVALID': 'El campo no permite los sig.  caracteres /*?"<>:\'',
            'COMPANY_ACOR': 'Nombre corto de empresa ',
            'MOD_INGRE_ACORT': 'Para continuar ingrese el nombre corto de empresa',
            'ACORT_REQUIRED': 'El nombre corto de la empresa es requerido',
            'SEDE': 'País sede',
            'SEDE_REQUIRED': 'Es necesario seleccionar el país sede para continuar',

            'PUBLICATION': 'Nombre de la empresa para la publicación ',
            'PUBLICATION_REQUIRED': 'El nombre de la empresa para la publicación es requerido',
            'FUNDATION': 'Año de fundación ',
            'FUNDATION_REQUIRED': 'El año de fundación de la empresa es requerido',
            'EMP_TC_REQUIRED': 'El número de empleados de tiempo completo es requerido',
            'EMP_TP_REQUIRED': 'Por favor complete el número de empleados de tiempo parcial',
            'TOTCOL_REQUIRED': 'Por favor complete el número total de colaboradores',
            'RANKING': 'Ranking ',
            'RANKING_REQUIRED': 'Por favor seleccione la clasificación',
            'TIPO': 'Rango de colaboradores ',
            'TIPO_REQUIRED': 'Por favor seleccione un rango',
            'MULTINACIONAL': 'Multinacional ',
            'MULTINACIONAL_REQUIRED': 'Por favor seleccione si es multinacional',
            'ANIORANK_REQUIRED': 'Ingrese el año de clasificación',
            'REGION': 'Región ',
            'REGION_REQUIRED': 'Ingrese su región',
            'NAM_RANKIN':'Nombre de clasificación',
            'TYP_RANKIN':'Tipo de clasificación',

            'PAIS': 'País ',
            'PAIS_REQUIRED': 'Ingrese su País',

            'ESTADO': 'Estado, ciudad o provincia',

            'OPTSI': 'Si',
            'OPTNO': 'No',

            'EMP_TC': 'Empleados de tiempo completo ',
            'EMP_TP': 'Empleados de tiempo parcial ',
            'TOTCOL': 'Número total de colaboradores ',
            'ANIORANK': 'Año de clasificación ',
            'ETIQ_CATALOGOS':{
              'SECTOR': 'Seleccione un sector',
              'SUBSECTOR': 'Seleccione un sub-sector',
              'MULTIN': 'Multinacional',
              'TIPO': 'Tipo (categoría o sector).',
              'REGION': 'Seleccione una región.'
            },
            'CATALOGOS':{
              'INSTITUTOS': catalogos.institutos,
              'SECTORES': catalogos.sectores,
              'RANKING': catalogos.ranking,
              'REGIONES': catalogos.regiones,
              'PAISES': catalogos.paises,
            }
          },
          'SEC2': {
            'TITULO': 'Responsable del proyecto',
            'NOM': 'Nombre ',
            'APE': 'Apellido ',
            'EMAIL': 'Correo electrónico ',
            'TEL': 'Teléfono ',
            'EXT': 'Extensión ',
            'CEL': 'Celular ',

            'NOM_REQUIRED': 'Ingrese un nombre',
            'APE_REQUIRED': 'Ingrese su apellido',
            'EMAIL_REQUIRED': 'Ingrese su correo electrónico',
            'TEL_REQUIRED': 'Ingrese su teléfono',
            'EXT_REQUIRED': 'Ingrese una extensión',
            'CEL_REQUIRED': 'Ingrese su celular'

          },
          'SEC3': {
            'TITULO': 'Director de recursos humanos',
            'NOM': 'Nombre completo ',
            'EMAIL': 'Correo electrónico ',
            'TEL': 'Teléfono ',
            'EXT': 'Extensión ',
            'CEL': 'Celular ',

            'NOM_REQUIRED': 'Ingrese un nombre',
            'EMAIL_REQUIRED': 'Ingrese su correo electrónico',
            'TEL_REQUIRED': 'Ingrese su teléfono',
            'EXT_REQUIRED': 'Ingrese una extensión',
            'CEL_REQUIRED': 'Ingrese su celular'

          },
          'SEC4': {
            'TITULO': 'Responsable de TI',
            'NOM': 'Nombre completo ',
            'EMAIL': 'Correo electrónico ',
            'TEL': 'Teléfono ',
            'EXT': 'Extensión ',
            'CEL': 'Celular ',
            'REGISTER': 'Registrar',

            'NOM_REQUIRED': 'Ingrese un nombre',
            'EMAIL_REQUIRED': 'Ingrese su correo electrónico',
            'TEL_REQUIRED': 'Ingrese su teléfono',
            'EXT_REQUIRED': 'Ingrese una extensión',
            'CEL_REQUIRED': 'Ingrese su celular'
          },
          'SEC5': {
            'TITULO': 'Entregables:',
            'ENTRE': 'Entregable:',
            'TIPO': 'Tipo:',

            'ENTRE_REQUIRED': 'Ingrese el entregable:',
          }
        },
        'MENSAJES':{
          'CARGABD': 'Subir base de datos',
          'STATUS': 'ESTADO',
          'CORRECTO': 'El perfil de empresa fue creado correctamente',
          'ERROR': 'Ocurrió un error al crear el perfil de empresa'
        }
      },
      'USUARIO':{
        'TITULO_LOGIN':'Seleccione el usuario con el que guste iniciar sesión',
        'MJS_COMPLETE_INFO': 'Por favor complete la información',
        'MSJ_INVALIDEMAIL': 'Por favor introduzca una dirección de correo electrónico válida',
        'MSJ_SELECTCOMPANY': 'Por favor seleccione una empresa',
        'REGISTER_SUCCESS': 'Usuario registrado exitosamente',
        'REGISTER_SUCCESS_SWIFT': 'Usuario registrado exitosamente, Se ha enviado un correo a su usuario para su activación',
        'REGISTER_ERROR': 'Error, el usuario no pudo registrarse, por favor intente nuevamente',
        'PRODUCT_REGISTEROK': 'Producto registrado correctamente',
        'PRODUCT_REGISTERPREVIOUS': 'Producto previamente registrado',
        'PRODUCT_REGISTERFAIL': 'Error al registrar el producto, intente nuevamente',
        'CERTIFICAR_EXISTENTE': 'El producto con certificar ya existe',
        'CERTIFICAR_NO_TERMINADO': 'Para  agregar el siguiente producto debe concluir con el certificar correspondiente al año',
        'CERTIFICAR_NO_EXISTENTE': 'Para agregar  el Producto Pulsecheck debe adquirir el certificar correspondiente al año',
        'PULSOS-COMPLETOS':'Actualmente ya cuenta con los pulsos permitidos',
        'MSJ_SELECTYEAR': 'Por favor seleccione un año',
        'MSJ_SELECTYEARRESULTS': 'Es necesario tener un producto tipo',
        'MSJ_34': 'Es necesario seleccionar un producto tipo Certificar',
        'MSJ_35': 'Es necesario seleccionar un producto tipo Medir',
        'MSJ_36': 'Es necesario seleccionar un producto tipo Forall',
        'MSJ_SELECTPRODUCT': 'Por favor seleccione un producto',
        'MSJ_SELECTTEMPLETE': 'Por favor seleccione una plantilla',
        'SIN_USUARIO': 'Necesita registrar un usuario a esta empresa para poder agregar este producto',
        //'SIN_SURVEYTOKEN': 'Necesita introducir la clave de encuesta a asociar a este producto para poder asignarlo',
        'MISMOANIOCERTIFICAR': 'No se puede agregar el producto, ya cuenta con un producto certificar del mismo año, seleccione un año diferente y vuelva a intentar',
        'SIN_SURVEYTOKEN': 'El año de tu producto aún no cuenta con una encuesta creada',
        'SIN_CERTIFICAR_ASOCIA': 'Necesita asociar aún producto certificar',
        'SIN_TABLEAUVER': 'Necesita introducir la versión de los resultados a asociar a este producto para poder asignarlo',
        'SINRANKING': 'Necesita seleccionar el año de ranking para este producto antes de continuar',
        'SINTIPORANK': 'Necesita seleccionar el tipo de ranking para este producto antes de continuar',
        'SINIDOPORTUNITY': 'Necesita introducir el ID de oportunidad para este producto antes de continuar',
        'SINNAMEOPORTUNITY': 'Necesita introducir el nombre de oportunidad para este producto antes de continuar',
        'SINIDTYPERESULT': 'Necesita introducir el tipo de resultado para este producto antes de continuar',
        'SINPROYECTMANAGER': 'Necesita introducir el nombre del jefe de proyecto para este producto antes de continuar',
        'SINCORREOPM': 'Necesita introducir el correo electrónico del jefe de proyecto para este producto antes de continuar',
        'EMAILNOVALIDO': 'El correo electrónico del jefe de proyecto introducido no tiene el formato válido, revíselo y vuelva a introducirlo correctamente',
        'GUARDANDOPRODUCTO': 'Se está agregando el producto seleccionado a la empresa, espere un momento',
        'TOKENMODAL_1': 'Este es el token de encuesta del producto recién agregado',
        'TOKENMODAL_2': '¿Qué desea hacer a continuación?',
        'TOKEN_SI': 'Copiar el token',
        'TOKEN_NO': 'Continuar',
        'TOKEN_COPIADO': 'El token de encuesta se copio al portapapeles correctamente',

        'ERROR1':'Ya tiene un producto registrado este año',
        'TITUHEAD': 'Perfil de usuario',
        'TITUCREARHEAD': 'Crear usuario',
        'TITUBUSCARHEAD': 'Buscar usuario',
        'TITUBUSCAREMPRESA': 'Buscar empresa',
        'TITUUSERGPTWHEAD': 'Usuarios Admin',
        'INFO': 'Perfil para un usuario',
        'USUARIO': 'Correo electrónico: ',
        'USE_NAM': 'Nombre de usuario ',
        'USUARIO_REQUIRED': 'El correo electrónico es requerido',
        'CONTRA_REQUIRED': 'La contraseña es requerida',
        'LEVEL_REQUIRED': 'Por favor seleccione un nivel',
        'COMPANY_REQUIRED': 'Por favor seleccione una empresa',

        'USUARIOREQUIRED': 'El correo electrónico es requerido',
        'USUARIONAMEREQUIRED': 'El nombre de usuario es requerido',
        'CONTRAREQUIRED': 'La contraseña es requerida',
        'longitud':'Mínimo 10 caracteres',
        'letraMin':'Un carácter en minúscula',
        'letraMayu':'Un carácter en mayúscula',
        'numeroPass':'Un número',
        'caracterPass':'Un carácter especial',
        'LEVELREQUIRED': 'Por favor seleccione un nivel',
        'CONTRA': 'Contraseña: ',
        'COMPANY': 'Empresa: ',
        'NIVEL': 'Nivel: ',
        'NIVELES': catalogos.niveles,
        'GUARDA': 'Guardar',
        'TH-NOMEMPRE':'Nombre Empresa',
        'TH-USUARIO':'Usuario',
        'TH-TUSUARIO':'Tipo Usuario',
        'TH-ACCIONES':'Acciones',
        'TH-LOGIN':'Iniciar sesión',
        'TH-INSTITUTO':'Instituto',
        'ACC-DELET':'Eliminar Usuario',
        'ACC-EDIT':'Editar Usuario',
        'UPDATE-USER':'Se actualizo correctamente',
        'EXIST-USER':'Usuario Existente',
        'ALERT-EDIT':'Estás seguro de modificar el usuario?',
        'USUARIO-T':'Users',
        'CONFIRM_ELIMINAR_USU':'Estas Seguro de eliminar el usuario?',
        'INGR_ELIMINAR_USU':'<span>Ingrese el usuario  marcado en rojo en el campo de Texto ',
        'INGR_ELIMINAR_USU.2':'</span>',
        'ERROR_ELIMINAR_USU':'El usuario ingresado no coincide',
        'OK_ELIMINAR_USU':'Se elimino correctamente el Usuario',
        'PASSWORDSAFE': 'La contraseña debería tener al menos 8 caracteres de longitud: al menos 1 dígito, al menos 1 minúscula, al menos 1 MAYÚSCULA y al menos 1 caracter no-alfanumérico',
        'PRODUCT_EXIST':'El producto con fecha seleccionada ya existe',
        'WAR_ADD_NA_US':'Porfavor ingrese el nombre de usuario',
        'WAR_ADD_TOT_US':'Porfavor ingrese el total de colaboradores',
        'WAR_ADD_EMA_US':'Porfavor ingrese el correo de usuario',
        'WAR_ADD_PASS_US':'Porfavor ingrese la contraseña del usuario',
        'WAR_INCO_EMA_US':'El correo ingresado es incorrecto',
        'WAR_INCO_PASS_US':'La contraseña no cuenta con el formato permitido',
        'MOD_SAV_US':'Guardando usuario',
        'MENSAJES':{
          'CARGABD': 'Subir base de datos',
          'STATUS': 'ESTADO',
          'CORRECTO': 'El perfil de usuario fue creado correctamente',
          'ERROR': 'Ocurrió un error al crear el perfil de usuario'
        }
      }
    },
    'CONSULTARENCUESTA':{
      'TITULO':'Consultar encuesta',
      'HEADER':'Seleccione el instituto',
      'INSTITUTOS':'Institutos',
      'FILTRO':'Filtro',
      'FILTRO_EMPRESA':'Filtro empresa:',
      'FILTRO_TI_EMPR_TOKEN':'Filtro token encuesta / tipo empresa:',
      'SELECCIONFILTRO':'Busque la información requerida',
      'BOTON_DESCARGA_EXCEL':'Descargar información en formato excel',

      'CARGANDO':'Cargando información...',
      'NOMBRE_DE_EMPRESA':'Nombre de la empresa',
      'TIPO_DE_EMPRESA':'Tipo de empresa',
      'FECHA_C':'Fecha de creación',
      'SECTOR':'Sector',
      'SUBSECTOR':'Subsector',
      'TIPO_ENC':'Tipo de encuesta',
      'PLANTILLA':'Plantilla',
      'CATALOGOSPRODUCTOS': catalogos.plantillas,
      'CATALOGOSNAMETH': catalogos.nameTHConsEncuesta,
      'TOKEN':'Survey token',
      'ID_ENC':'Id de encuesta',
      'ANIO':'Año',
      'CORREOS_EN':'Correos enviados',
      'FECHA_A':'Fecha de aplicación',
      'FECHA_CR':'Fecha de cierre',


      'MODAL_SUCCES':'Archivo descargado correctamente',
      'MODAL_WARNING':'No ha seleccionado ningun instituto',

      'MEXICO':'México',
      'CENTROAMERICAYELCARIBE':'Centroamérica y El Caribe',
      'CHINAYHK':'China y Gran China',
      'FILIPINAS':'Filipinas',
      'SINGAPUR':'Singapur',
      'TURQUIA':'Turquia',
      'VIZUENCU':'Visualizar encuestas',
      'SELE_AN_ENCU':'Seleccione un año',


    },
    'CONSULTAR_RT':{
      'TITULO':'Consultar requerimientos técnicos',
      'HEADER':'Seleccione el instituto',
      'INSTITUTOS':'Institutos',
      'FILTRO':'Filtro',
      'SELECCIONFILTRO':'Busque la empresa requerida',
      'CARGANDO':'Cargando información...',
      'NOMBRE_DE_EMPRESA':'Nombre de la empresa',
      'FECHA_DE_EMPRESA':'Fecha creación',
      'PRODUCTO':'Tipo de producto',
      'TOKEN':'Token encuesta',
      'ESTATUS':'Estatus',
      '0':'No iniciado',
      '1':'En proceso',
      '2':'Terminado',
      'ACCIONES':'Acciones',
      'PRODUCTOS':catalogos.productos,
      'ELEMENTOS':'Elementos por página',
      'DE':'de',
      'SIGUIENTE':'Siguiente',
      'ULTIMA':'Última página',
      'PRIMERA':'Primera página',
      'ANTERIOR':'Anterior'


    },
    'PAQUETES':{
      'NOMBRES':{
        '1': 'Paquete PLATA',
        '2': 'Paquete ORO',
        '3': 'Paquete PLATINO',
      },
      'TOOLTIP':{
        'CONFIG': 'Haga clic para configurar',

      },
      'MENSAJES': {
        'ADDOK': 'El paquete fue agregado a la empresa de manera correcta. A continuación podrá configurar los productos del paquete seleccionado',
        'NOTOK': 'No se pudo agregar el paquete, ya existe un paquete asignado al año especificado, intente nuevamente eligiendo otra opción',
        'USURE_PROD': '¿Confirma configurar este producto con las características elegidas?',
        'PROD_ACTIVADO': 'Este producto ya se encuentra activado',
        'ONLYONE': 'En esta categoría sólo se puede elegir un tipo de producto, ¿Desea continuar el proceso con esta elección?',
        'NOYEAR': 'No ha seleccionado el año de aplicación para el paquete',
        'NOPAQ': 'No ha seleccionado el paquete a asignar',
      },
      'PREVIO':{
        'INFO': 'No cuenta con un paquete de productos vigente',
        'BOTONES':{
          'ADD': 'Agregar un paquete',
          'SEE': 'Consultar un paquete anterior',
          'CANCELAR': 'Cancelar',
          'ADDPACK': 'Agregar paquete',
          'SI': 'Si',
          'NO': 'No',
        },
        'STEPS': {
          '1': 'Seleccione el paquete que desee asignar a la empresa',
          '2': 'Seleccione el año de aplicación para el paquete',
        }
      },
      'INFOPAQ':{
        'TITULO': 'Paquete actual:',
        'APLICA': 'Año de aplicación:',
        'AVANCE': 'Avance de configuración del paquete',
        'STATUS':{
          'TITULO': 'Estado:',
          'OK_1': 'Configuración completa',
          'NOTOK_1': 'Configuración incompleta',
          'OK_2': 'Activación completa',
          'NOTOK_2': 'No activado',
          'ADICIONAL': 'Productos adicionales',
          'ADINFO': 'Nota: Su adición es opcional',
        },
        'BOTONES':{
          'ADD': 'Agregar producto',
          'CANCELAR': 'Cancelar',
          'SI': 'Si',
          'NO': 'No',
          'BACK': 'Regresar',
          'ADDONE': 'Agregar un producto',
          'DETAIL': 'Ver detalles',
        },
        'CERTIFICAR':{
          'TITULO':{
            '1': 'No ha activado este producto',
            '2': 'Ya ha activado este producto',
            '3': 'Esta es una categoría, puede activar los siguientes productos:',
            '4': 'Este producto puede asignarse mas de una vez durante la duración del paquete',
          },
          'INSTRUC': 'Configure este producto a continuación',
          'TIPO': 'Seleccione el tipo de producto',
          'INFO':{
            'TITULO': 'Datos del producto',
            'SECCIONES': 'Secciones',
            'TIPO': 'Tipo',
            'TEMP': 'Plantilla seleccionada',
            'STATUS':{
              'TITULO': 'Estado actual',
              '1': 'Aún no terminado',
              '2': 'Terminado',
            },
            'TABLA':{
              '1': 'Producto',
              '2': 'Opciones'
            }
          }
        }
      }
    },
    'AUDITORIA-AUTOMATICA':{
      'TITULO': 'Auditoría automatizada',
      'TABLA':{
        'TH-NOM-EMPRESA':'Nombre de la Empresa',
        'TH-NO-COLAB':'No. Colaboradores',
        'TH-CONTESTADOS':'Contestadas',
        'TH-FALTANTES':'Faltantes',
        'TH-PROGRESO':'Progreso',
        'TH-ACCIONES':'Acciones',
        'MSJ-DETALLES':'Ver detalles',
      }

    },
    'RESULTA-AUDITO':{
      'TIEM-RES-TAB':'Tiempo respuesta colaboradores',
      'RES-CONT-TAB':'Respuestas de control',
      'RES-COMENT-TAB':'Respuestas de comentarios',
      'TIEM-RES-TITULO':'Verifica el tiempo de respuesta de los colaboradores',
      'RES-CONT-TITULO':'Porcentaje de respuesta de las preguntas de control',
      'RES-COMENT-TITULO':'Porcentaje de comentarios vacios, repetidos o con caracteres repetidos',
      'RES-AGREGAR':'Agregar una muestra',
      'RES-SELECCIONAR':'Seleccionar muestra',
      'RES-TEXTO1':'Aún no se ha creado ninguna muestra',
      'RES-TEXTO2':'Por favor seleccione una muestra para visualizar los datos',
      'INGRE-NOM':'Ingresa el nombre de la muestra',
      'SELEC-REG':'Selecciona las reglas de la muestra',
      'REGLAS':{
        '1': 'Colaboradores que contestaron en menos de 10 minutos',
        '2': 'Colaboradores que contestaron todos sus reactivos con valor 5',
        '3': 'Colaboradores que contestaron SI en la pregunta de control',
        '4': 'Colaboradores que contestaron pregunta aleatoria incorrecto',
        '5': 'Colaboradores que cambiaron mas de 10 de respuestas',
      },

      'TABLA':{
        'TITULO':'Datos de los colaboradores en la muestra',
        'NOMBRE':'Nombre',
        'TELEFONO':'Teléfono',
        'CELULAR':'Celular',
        'CORREO':'Correo electrónico',
        'COMENTARIO':'Comentario',
      },

      'MODALES':{
        'GENERANDO':'Generando muestra, por favor espere...',
        'GUARDANDO':'Guardando comentario, por favor espere...',
        'TITULO':'Comentario guardado',
        'CERRAR':'Cerrar',
        'TITULO_INFORMACION':'Una vez que haya agregado el comentario el campo no se podra quedar vacio, se tomaran los ultimos datos guardados en el mismo',
        'SUCCE-MUES': 'se creo correctamente la muestra',
        'WARNI-SINU': 'Ya no quedan usuarios para registrar',
        'WARNI-CONDI': 'No olvides colocar un nombre y selecccionar al menos una regla',


      },
    },
    'DESCARGAR_ENCUESTA':{
      'NPS':'NPS',
      'REACTIVOS':'Reactivos',
      'CONTROL':'Control',
      'DEMOGRAFICOS':'Demográficos',
      'ABIERTAS':'Abiertas',
      'CA':'4ALL',
      'CODIGOPROYECTO':'Código de proyecto: ',
      'ANIOAPLICACION':'Año de aplicación: ',
      'MENSAJE':'No es posible descargar la encuesta, porque aun no se ha creado',
      'ACEPTAR':'Aceptar',
      'TEXTODESCARGA':'Encuesta de ',
      'DESCARGARENCUESTA':'Descargar encuesta',
      'INFORMACIONYAVISO':'Información de la encuesta y aviso de privacidad',
      'SECCIONES':'Secciones',
      'TIPOENC1':'Menos 50',
      'TIPOENC2':'Más de 50',
      'MODAL':{
        'TITLE':'Lista de idiomas',
        'SUBTITLE':'Seleccione un idioma',
        'PLACEHOLDER':'Ninguno',
        'BTNCLOSE':'Cerrar',
        'BTNSELECT':'Descargar',
        'MAS50':'Más de 50',
        'MENOS50':'Menos de 50',
        'TIPOENCUESTA':'Seleccione tipo de encuesta',
      }
    },
    'UPDATE_COLABORATORS':{
      'UPDATE':'Actualizar base de datos de colaboradores'
    },
    'INFORT': {
      'TITULO': 'Avance de requerimientos técnicos',
      'SINLANGS': 'Es necesario seleccionar idiomas en este producto para ver la lista de pasos',
      'PASOS': {
        'PASO_1': 'Lista de pasos',
        'PASO_2': 'Cuestionario',
        'PASO_3': 'Historial'
      },
      'LISTAPASOS': {
        'autentication': 'Autenticación de encuesta',
        'testAccess': 'Prueba de visualización',
        'testEmail': 'Prueba de recepción de correo electrónico',
        'validationQ': 'Cuestionario de validación',
        'requirements': 'Politica de privacidad de datos',
      },
      'STATUS': {
        'PEND': 'Pendiente',
        'DONE': 'Paso completo',
      },
      'RESP': 'Respuesta enviada',
      'NORESP': 'Sin respuesta'
    },
    'MODAL_CONSULT_INFRAESTRU':{
      'TITL':'Infraestructura dedicada:',
      'INSTRUC_1':'¿Deseas agregar infraestructura dedicada?',
      'LAB_SUBDOMINIO':'SubDominio',
      'WARN_CARACT':'El campo no permite la letra ñ, letras en mayusculas y caracteres especiales',
      'BTN_CONTI':'Continuar',
      'SI':'Si',
      'NO':'No',
      'MODA_IMPORT_SUBDOM':'Para continuar es necesario ingresar el subdominio',
    }
  }
};
